import { render, staticRenderFns } from "./LoginSocialRedirect.vue?vue&type=template&id=abbadf40&scoped=true"
import script from "./LoginSocialRedirect.vue?vue&type=script&lang=js"
export * from "./LoginSocialRedirect.vue?vue&type=script&lang=js"
import style0 from "./LoginSocialRedirect.vue?vue&type=style&index=0&id=abbadf40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbadf40",
  null
  
)

export default component.exports